import { WeeklySummary } from '@amzn/aet-summaries-kit';
import useInspireOptions from '../../../hooks/useInspireOptions';
import { useMemo } from 'react';

const useDidRequestorProvideFeedback = (summary?: WeeklySummary) => {
  const { requesterUsername } = useInspireOptions();

  return useMemo(
    () => summary?.feedbackProviders?.includes(requesterUsername) ?? false,
    [requesterUsername, summary?.feedbackProviders]
  );
};

export default useDidRequestorProvideFeedback;
